import { useMemo } from 'react';
import Image from 'next/image';
import { useTranslation } from 'react-i18next';

import { Box, Flex } from '@chakra-ui/react';

import { ContentContainer } from '~/components/container';
import { Link } from '~/components/link';
import { useExperiment } from '~/features/experiments/hooks/use-experiment';
import { useStickyPriceTrackRendered } from '~/features/program/hooks/use-sticky-price-track-rendered';
import { useBaseUrl } from '~/hooks/use-base-url';
import { useCatalogPath } from '~/hooks/use-catalog-path';

import { getNavigationData } from '../data';

import { Legal } from './legal';
import { Navigation } from './navigation';
import { NewsletterSignUp } from './newsletter';
import { SocialMedia } from './social-media';

export function PageFooter() {
  const baseUrl = useBaseUrl();
  const { t } = useTranslation();
  const catalogPath = useCatalogPath();
  const navigationData = useMemo(() => getNavigationData(t, catalogPath), [t, catalogPath]);
  const isNewPLPDesign = useExperiment()?.ab_plp_redesign_2025 === 'variant_b';
  const isStickyPriceTrackRendered = useStickyPriceTrackRendered();

  return (
    <Box
      bgColor='white'
      borderTop='solid 1px'
      borderTopColor='gray.300'
      paddingBottom={
        isNewPLPDesign
          ? 'var(--mobile-sticky-banner-offset)'
          : isStickyPriceTrackRendered
            ? { base: '40px', md: 'unset' }
            : undefined
      }
    >
      <ContentContainer>
        <Box as='footer' py='64px'>
          <Link aria-label='Link to home page' display='flex' href={baseUrl} locale={false} width='fit-content'>
            <Image alt='Udacity Accenture logo' height={32} src='/images/udacity-accenture-logo.svg' width={170} />
          </Link>

          <Box h={{ base: '24px', xl: '40px' }} />

          <Navigation navigation={navigationData} />

          <Box h='40px' />

          <Flex
            alignItems={{ base: 'flex-start', md: 'flex-end' }}
            flexDirection={{ base: 'column', md: 'row' }}
            gap={{ base: '40px', md: '16px' }}
            justifyContent='space-between'
          >
            <NewsletterSignUp />
            <SocialMedia />
          </Flex>
          {/* <CollapsableNavigation /> */}
          <Legal />
        </Box>
      </ContentContainer>
    </Box>
  );
}
